// import * as React from 'react'
import React, { useContext } from 'react'
import { Link, withRouter, RouteComponentProps } from 'react-router-dom'
import LogoGoin from '../icons/ui/LogoGoin'
import IconSignupSuccess from '../icons/ui/IconSignupSuccess'
import { withNotification } from '../ui/notification-provider'

interface ISignupSuccess extends RouteComponentProps<any> {
  resendInviteEmail: any
  notification?: any
}

const SignupSuccess = (props: ISignupSuccess) => {
  const url = `auth/${props.match.params.role}/register`

  const resendInviteEmail = () =>
    props
      .resendInviteEmail({ emailAddress: props.match.params.email })
      .then(() => {
        const { notification } = props
        notification.addNotification({
          title: 'Success',
          message: 'Verification mail sent successfully',
          level: 'success'
        })
      })
      .catch(() => {
        const { notification } = props
        notification.addNotification({
          title: 'Error',
          message: 'Something went wrong please try again',
          level: 'error'
        })
      })

  return (
    <div className='col-12 absolute top-0 bottom-0 left-0 right-0 flex flex-wrap direction-column justify-center items-center'>
      <div className='col-10 flex justify-center item-direction flex-wrap items-center'>
        <div className='flex justify-center'>
          <LogoGoin className='margin-auto block icon--100x100' />
        </div>
        <div className='titleText w950 bold fs-30 flex justify-center mt2'>Check your Email</div>
        <div className='imgBox mt1 pt1 mb1'>
          <IconSignupSuccess className='margin-auto block icon--100x145' />
        </div>
        <div className='mainText w950 flex justify-center mt1 pt1 mb05'>
          <p className='text-center'>
            Before you start using Branch, we need you to verify your email address. An email containing verification
            instructions was sent to
            <span className='weight-600 ml01 mr01'>{props.match.params.email}</span> with a link to verify your account.
          </p>
        </div>
        <div className='resendText w100 flex justify-center mt2 mb5'>
          Didn’t get the email? Check your spam folder or{' '}
          <span className='resendLink' onClick={resendInviteEmail}>
            Resend
          </span>{' '}
          verification email.
        </div>
        <div className='signupText w100 flex justify-center'>
          Incorrect email address? <Link to={url}>Sign Up</Link> to start over.
        </div>
      </div>
    </div>
  )
}

export default withNotification(withRouter(SignupSuccess))



// WEBPACK FOOTER //
// ./src/components/authentication/SignupSuccess.tsx